export default __webpack_public_path__ + "static/media/csv_template.51436298.csv";